export const lineFontSize = 16;
export const lineFont = 'Roboto-GMM, Roboto, sans-serif';

export function getFont(): string {
  return lineFontSize + 'px ' + lineFont;
}
